/** main-map-query-content: formatted popup for querying the map */

<template>
    <div class="main-map-query-popup">
        <h4 v-html="queryLeader"></h4>
        <p v-if="showMPAs || showByelaws">Use the buttons below to find out more information about each MPA, including any condition information from the <strong>Recovery Check</strong>.</p>

        <h4 v-if="showMPAs">MPAs</h4>
        <button class="query-button btn btn-lg btn-primary"
                v-for="mcz in queryData.MPAs.MCZ"  v-on:click.prevent="$emit('query-boundary', ['MCZ', mcz[1]])">
            {{ mcz[0] }} MCZ
        </button>

        <button class="query-button btn btn-lg btn-success"
                v-for="sac in queryData.MPAs.SAC"  v-on:click.prevent="$emit('query-boundary', ['SAC', sac[1]])">
            {{ sac[0] }} SAC
        </button>

        <button class="query-button btn btn-lg btn-info"
                v-for="spa in queryData.MPAs.SPA"  v-on:click.prevent="$emit('query-boundary', ['SPA', spa[1]])">
            {{ spa[0] }} SPA
        </button>

        <button class="query-button btn btn-lg btn-warning"
                v-for="ncmpa in queryData.MPAs.NCMPA"  v-on:click.prevent="$emit('query-boundary', ['NCMPA', ncmpa[1]])">
            {{ ncmpa[0] }} NCMPA
        </button>


        <h4 v-if="showByelaws">Byelaws</h4>
        <button class="query-button btn btn-lg btn-danger"
                v-for="byelaw in queryData.demersal_byelaws"  v-on:click.prevent="$emit('query-boundary', ['byelaw', byelaw[0]])">
            {{ byelaw[1] }}
        </button>
    </div>
</template>


<script>


export default {
    name: "main-map-query-content",
    props: {
        queryData: {type: Object, required: true},
    },
    computed: {
        showMPAs: function () {
            return this.queryData.MPAs.MCZ.length > 0 || this.queryData.MPAs.SAC.length > 0 ||
                this.queryData.MPAs.SPA.length > 0 || this.queryData.MPAs.NCMPA.length > 0
        },
        showByelaws: function () {
            return this.queryData.demersal_byelaws.length > 0;
        },
        queryLeader: function () {
            if (this.queryData.leader.length > 0) {
                return this.queryData.leader
            }
        }
    }
}
</script>


<style lang="scss">
    @import "../../styles/variables.scss";

    .main-map-query-popup {
        h4 {
            font-weight: normal;
            margin-bottom: 10px;
        }

        .query-button {
            max-width: 280px;
            margin: 0 10px 10px 0;
            font-size: 100%;
        }
    }
</style>